import React, {useState, useEffect} from 'react';
import {withTranslation, useTranslation} from "react-i18next";
import Table from "./components/Table";
import Summary from "./components/Summary";
import Transfers from "./components/Transfers";
import "./AppOutput.css";

function App({t}) {
  const [expenses, setExpenses] = useState([{name: '', sum: ''}]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [averageExpense, setAverageExpense] = useState(0);
  const [shareUrl, setShareUrl] = useState('');

  // Parse URL parameters and update state
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const expenseEntries = Array.from(searchParams.entries()).filter(
        ([key, _]) => key === 'item');
    if (expenseEntries.length > 0) {
      const expenses = expenseEntries.map(([_, value]) => {
        let parts = value.split("|");
        return {name: parts[0], sum: parts[1] || 0};
      });
      setExpenses(expenses);
    }
  }, []);

  useEffect(() => {
    // Calculate total expenses and average expense per person
    let total = 0;
    let filteredExpenses = expenses.filter(
        ex => ex.sum && !isNaN(ex.sum) && !isNaN(parseInt(ex.sum)));
    filteredExpenses.forEach((expense) => (total += parseInt(expense.sum)));
    let average = total / filteredExpenses.length;
    average = isNaN(average) ? 0 : average;

    setTotalExpenses(total);
    setAverageExpense(average);

    // Generate shareable URL
    const urlParams = new URLSearchParams();
    expenses.forEach((expense) => {
      urlParams.append('item', expense.name + "|" + expense.sum);
    });
    setShareUrl(
        `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`);
  }, [expenses]);

  const handleAddRow = () => {
    setExpenses([...expenses, {name: '', sum: ''}]);
  };

  const handleDeleteRow = (index) => {
    const newExpenses = [...expenses];
    newExpenses.splice(index, 1);
    setExpenses(newExpenses);
  };

  const handleUpdateRow = (index, event) => {
    const { name, value } = event.target;
    const newExpenses = [...expenses];
    newExpenses[index][name] = value;
    setExpenses(newExpenses);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: t("title"),
        url: shareUrl,
      });
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert('URL copied to clipboard!');
    }
  };

  const handleNew = () => {
    setExpenses([{name: '', sum: ''}]);
  }

  const { i18n } = useTranslation();
  const params = window.location.search;
  const root = document.getElementsByTagName('html')[0];
  console.log(`@@@ lng: ${params} - ${i18n.language} - ${root.getAttribute("dir")}`);
  if (params.includes("lng=en") && (i18n.language !== "en" || root.getAttribute("dir") !== "ltr")) {
    console.log("update lang to en");
    i18n.changeLanguage("en");
    root.setAttribute("dir", "ltr");
  }
  if (!params.includes("lng=en") && (i18n.language !== "he" || root.getAttribute("dir") !== "rtl")) {
    console.log("update lang to he");
    i18n.changeLanguage("he");
    root.setAttribute("dir", "rtl");
  }

  return (
      <div className="flex flex-col h-screen">
        <div className="flex-grow">
          <div className="max-w-lg mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold text-center mb-8">{t("title")}</h1>
            <Table t={t} expenses={expenses} onDelete={handleDeleteRow} onUpdate={handleUpdateRow} onAdd={handleAddRow} />
            <Summary t={t} totalExpense={totalExpenses} averageExpense={averageExpense} />
            <Transfers t={t} expenses={expenses} averageExpense={averageExpense} />
            <div className="inline-flex justify-center w-full">
              <div className="flex my-10"  role="group">
                <div className="bg-blue-300 hover:bg-blue-500 text-gray-800 font-bold py-4 px-8 rounded-s border">
                  <button onClick={handleShare}>{t("share")}</button>
                </div>
                <div className="bg-blue-300 hover:bg-blue-500 text-gray-800 font-bold py-4 px-8 rounded-e border">
                  <button onClick={handleNew}>{t("new")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-300 py-4 text-center text-sm">
          <a href="https://bafla.app/" target="_blank" rel="noreferrer" className="hover:text-blue-600">{t("bafla_plug")}</a>
        </div>
        <div className="bg-gray-300 py-4 text-center text-sm">
          <a href="https://crossword.gazith.com/" target="_blank" rel="noreferrer" className="hover:text-blue-600">{t("crossword_plug")}</a>
        </div>
        <footer className="bg-gray-200 py-4 text-center text-gray-600 text-sm">
          {t("rights")}
        </footer>
      </div>
  );
}

export default withTranslation()(App);
